const KEY_AUTH = 'auth';

const KEY_ME = 'Me';
const KEY_LICENSE = 'license';
const KEY_ORDERS = 'orders';
const KEY_ORDERS_SUMMARY = 'orders-summary';

const KEY_REFUELING_ORDERS = 'refueling-orders';
const KEY_PARKING_ORDERS = 'parking-orders';
const KEY_ON_STREET_PARKING_ORDERS = 'on-street-parking-orders';

const KEY_GAS_STATIONS = 'gas-stations';
const KEY_PARKINGLOTS = 'parkinglots';
const KEY_CHAIN_STORES = 'chain_stores';
const KEY_VEHICLE_MAINTENANCE = 'vehicle_maintenance';
const KEY_VEHICLE_REPAIR = 'vehicle_repair';
const KEY_WASH_CAR = 'wash_car';
const KEY_CHARGING = 'charging';
const KEY_PROMOTION_COLLECTIONS = 'promotion-collections';
const KEY_PROMOTION_COLLECTION_BOARDS = 'promotion-collection-boards';
const KEY_PROMOTIONS = 'promotions';
const KEY_PROMOTION_BOARDS = 'promotion-boards';
const KEY_VIEWED_AUTOPASS_GAS_STATIONS = 'viewed_autopass_gas_stations';

class LocalDataService {
  // login
  getAuth = () => {
    return this.getLocalCache(KEY_AUTH);
  };

  saveAuth = obj => {
    localStorage.setItem(KEY_AUTH, JSON.stringify(obj));
  };

  getMe = () => {
    return this.getLocalCache(KEY_ME);
  };

  saveMe = obj => {
    localStorage.setItem(KEY_ME, JSON.stringify(obj));
  };

  // 車牌
  getLicensePlates = () => {
    return this.getLocalCache(KEY_LICENSE);
  };
  saveLicensePlates = obj => {
    localStorage.setItem(KEY_LICENSE, JSON.stringify(obj));
  };
  // 消費過車牌
  saveActiveLicensePlates = obj => {
    return localStorage.setItem(KEY_LICENSE, JSON.stringify(obj));
  };
  // 加油消費資訊
  getRefuelingOrders = () => {
    return this.getLocalCache(KEY_REFUELING_ORDERS);
  };
  saveRefuelingOrders = obj => {
    localStorage.setItem(KEY_REFUELING_ORDERS, JSON.stringify(obj));
  };
  // 停車消費資訊
  getParkingOrders = () => {
    return this.getLocalCache(KEY_PARKING_ORDERS);
  };
  saveParkingOrders = obj => {
    localStorage.setItem(KEY_PARKING_ORDERS, JSON.stringify(obj));
  };
  // 路停消費資訊
  getOnStreetParkingOrders = () => {
    return this.getLocalCache(KEY_ON_STREET_PARKING_ORDERS);
  };
  saveOnStreetParkingOrders = obj => {
    localStorage.setItem(KEY_ON_STREET_PARKING_ORDERS, JSON.stringify(obj));
  };
  // 消費資訊
  getOrders = () => {
    return this.getLocalCache(KEY_ORDERS);
  };
  saveOrders = obj => {
    localStorage.setItem(KEY_ORDERS, JSON.stringify(obj));
  };
  //消費服務開通
  getOrdersSummary = () => {
    return this.getLocalCache(KEY_ORDERS_SUMMARY);
  };
  saveOrdersSummary = obj => {
    localStorage.setItem(KEY_ORDERS_SUMMARY, JSON.stringify(obj));
  };

  // poi

  saveGasStations = gasStations => {
    sessionStorage.setItem(KEY_GAS_STATIONS, JSON.stringify(gasStations));
  };

  getGasStations = () => {
    return this.getSessionCache(KEY_GAS_STATIONS);
  };

  saveParkinglots = parkinglots => {
    sessionStorage.setItem(KEY_PARKINGLOTS, JSON.stringify(parkinglots));
  };

  getParkinglots = () => {
    return this.getSessionCache(KEY_PARKINGLOTS);
  };

  saveChainStores = chainStores => {
    sessionStorage.setItem(KEY_CHAIN_STORES, JSON.stringify(chainStores));
  };

  getChainStores = () => {
    return this.getSessionCache(KEY_CHAIN_STORES);
  };

  saveVehicleMaintenance = vehicleMaintenance => {
    sessionStorage.setItem(KEY_VEHICLE_MAINTENANCE, JSON.stringify(vehicleMaintenance));
  };

  getVehicleMaintenance = () => {
    return this.getSessionCache(KEY_VEHICLE_MAINTENANCE);
  };

  saveVehicleRepair = vehicleRepair => {
    sessionStorage.setItem(KEY_VEHICLE_REPAIR, JSON.stringify(vehicleRepair));
  };

  getVehicleRepair = () => {
    return this.getSessionCache(KEY_VEHICLE_REPAIR);
  };

  saveWashCar = washCar => {
    sessionStorage.setItem(KEY_WASH_CAR, JSON.stringify(washCar));
  };

  getWashCar = () => {
    return this.getSessionCache(KEY_WASH_CAR);
  };

  saveCharging = charging => {
    sessionStorage.setItem(KEY_CHARGING, JSON.stringify(charging));
  };

  getCharging = () => {
    return this.getSessionCache(KEY_CHARGING);
  };

  // promotions

  savePromotionCollections = promotionCollections => {
    sessionStorage.setItem(KEY_PROMOTION_COLLECTIONS, JSON.stringify(promotionCollections));
  };

  getPromotionCollections = () => {
    return this.getSessionCache(KEY_PROMOTION_COLLECTIONS);
  };

  savePromotionCollectionBoards = boards => {
    sessionStorage.setItem(KEY_PROMOTION_COLLECTION_BOARDS, JSON.stringify(boards));
  };

  getPromotionCollectionBoards = () => {
    return this.getSessionCache(KEY_PROMOTION_COLLECTION_BOARDS);
  };

  savePromotions = promotions => {
    sessionStorage.setItem(KEY_PROMOTIONS, JSON.stringify(promotions));
  };

  getPromotions = () => {
    return this.getSessionCache(KEY_PROMOTIONS);
  };

  savePromotionBoards = boards => {
    sessionStorage.setItem(KEY_PROMOTION_BOARDS, JSON.stringify(boards));
  };

  getPromotionBoards = () => {
    return this.getSessionCache(KEY_PROMOTION_BOARDS);
  };

  // 進入車麻吉通路時紀錄
  saveViewedAutopassGasStations = () => {
    localStorage.setItem(KEY_VIEWED_AUTOPASS_GAS_STATIONS, true);
  };

  getViewedAutopassGasStations = () => {
    return localStorage.getItem(KEY_VIEWED_AUTOPASS_GAS_STATIONS);
  };

  getLocalCache = key => {
    let local = localStorage.getItem(key);
    return (local = null ? undefined : JSON.parse(local));
  };

  getSessionCache = key => {
    let session = sessionStorage.getItem(key);
    return session === null ? undefined : JSON.parse(session);
  };

  clearStorage = () => {
    if (this.getViewedAutopassGasStations()) {
      localStorage.clear();
      this.saveViewedAutopassGasStations();
    } else {
      localStorage.clear();
    }

    sessionStorage.clear();
  };

  clearSessionStorage = () => {
    sessionStorage.clear();
  };
}

export default new LocalDataService();
